/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PatientBannerComponent } from './patient-banner.component';
import { SelectDropdownModule } from '../select-dropdown/select-dropdown.module';
import { TooltipModule } from '../tooltip/tooltip.module';

const components = [PatientBannerComponent];
@NgModule({
  declarations: components,
  exports: components,
  entryComponents: components,
  imports: [CommonModule, AngularSvgIconModule, SelectDropdownModule, TooltipModule]
})
export class PatientBannerModule {}

export { PatientBannerComponent };
